import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// 이메일 함수 타입 정의
interface EmailResponse {
  success: boolean;
  message: string;
}

interface WelcomeEmailData {
  email: string;
  name?: string;
}

interface PasswordResetEmailData {
  email: string;
}

interface OrderConfirmationEmailData {
  email: string;
  orderNumber: string;
  customerName?: string;
  items?: Array<{
    name: string;
    quantity: number;
    subtotal: number;
  }>;
  total?: number;
  restaurantName?: string;
}

/**
 * 환영 이메일 발송
 */
export const sendWelcomeEmail = async (data: WelcomeEmailData): Promise<EmailResponse> => {
  try {
    const sendEmail = httpsCallable<WelcomeEmailData, EmailResponse>(
      functions,
      'sendWelcomeEmail'
    );
    const result = await sendEmail(data);
    return result.data;
  } catch (error: any) {
    console.error('Welcome email error:', error);
    throw new Error(error.message || 'Failed to send welcome email');
  }
};

/**
 * 비밀번호 재설정 이메일 발송
 */
export const sendPasswordResetEmail = async (data: PasswordResetEmailData): Promise<EmailResponse> => {
  try {
    const sendEmail = httpsCallable<PasswordResetEmailData, EmailResponse>(
      functions,
      'sendPasswordResetEmail'
    );
    const result = await sendEmail(data);
    return result.data;
  } catch (error: any) {
    console.error('Password reset email error:', error);
    throw new Error(error.message || 'Failed to send password reset email');
  }
};

/**
 * 주문 확인 이메일 발송
 */
export const sendOrderConfirmationEmail = async (data: OrderConfirmationEmailData): Promise<EmailResponse> => {
  try {
    const sendEmail = httpsCallable<OrderConfirmationEmailData, EmailResponse>(
      functions,
      'sendOrderConfirmationEmail'
    );
    const result = await sendEmail(data);
    return result.data;
  } catch (error: any) {
    console.error('Order confirmation email error:', error);
    throw new Error(error.message || 'Failed to send order confirmation email');
  }
};

/**
 * 사용자 완전 삭제 (Firebase Auth + Firestore)
 */
export const deleteUserCompletely = async (userId: string): Promise<EmailResponse> => {
  try {
    const deleteUser = httpsCallable<{ userId: string }, EmailResponse>(
      functions,
      'deleteUserCompletely'
    );
    const result = await deleteUser({ userId });
    return result.data;
  } catch (error: any) {
    console.error('Delete user error:', error);
    throw new Error(error.message || 'Failed to delete user');
  }
};

